import React from "react";

import { Wrapper, Icon, Heading, Text } from "./styles";

const KeyFeatureItem = ({ content, shade, ...props }) => {
  return (
    <Wrapper {...props}>
      {content.icon && (
        <Icon src={`/img/${content.icon.relativePath}`} alt="" />
      )}
      {content.heading && <Heading shade={shade}>{content.heading}</Heading>}
      {content.text && <Text shade={shade}>{content.text}</Text>}
    </Wrapper>
  );
};

export default KeyFeatureItem;
